import { useState, useEffect, useContext, useMemo } from "react";

// @mui material components
import Card from "@mui/material/Card";

// Trakib components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAlert from "components/MDAlert";
import DataTable from "examples/Tables/DataTable";
import MDButton from "components/MDButton";
import {
  Tooltip,
  Grid,
  Dialog,
  Icon,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import CsvDownloadButton from "react-json-to-csv";
import CrudService from "services/cruds-service";
import { AuthContext } from "context";
import { AbilityContext } from "Can";
import { useAbility } from "@casl/react";
import i18n from "i18n";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import IdCell from "components/table/IdCell";
import DefaultCell from "components/table/DefaultCell";
import StatusCell from "components/table/StatusCell";
import CustomerCell from "components/table/CustomerCell";
import FilterDonation from "../filter-donations";
import moment from "moment";
import colors from "assets/theme/base/colors";
import MailComposerDialog from "components/MailComposerDialog";
import ProfilesList from "examples/Lists/ProfilesList";
import FormField from "components/FormField";

import { PDFDownloadLink } from "@react-pdf/renderer";
import { ReceiptPdf } from "components/ReceiptPdf";
import DonationDialog from "components/DonationDialog";
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";
import { DownloadButton } from "components/ReceiptDownload";

function Donations() {
  let { state } = useLocation();
  const { t } = i18n;
  const { filter } = useParams();

  // &filter[OrderId][_contains]=sy
  const [donations, setDonations] = useState([]);
  const [meta, setMeta] = useState(null);
  const [page, setPage] = useState(1);
  const [sortVal, setSortVal] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [limitChange, setLimitChange] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [filterUrl, setFilterUrl] = useState(filter || "");
  const [filterUrlForSum, setFilterUrlForSum] = useState(filter || "");
  const [filterData, setFilterData] = useState(false);
  const [cData, setCData] = useState([]);
  const [open, setOpen] = useState(false);
  const [notesOpen, setNotesOpen] = useState(false);
  const [notes, setNotes] = useState("");
  const [cartItemsData, setCartItemsData] = useState([]);
  const [cartDataId, setCartDataId] = useState(null);

  const baseUrl = process.env.REACT_APP_API_URL;

  const [notification, setNotification] = useState({
    value: false,
    text: "",
  });
  const reqUrl = `items/donation?fields=*,user_created.avatar,user_created.id,user_created.first_name,project_id.translations.name,donation_items.*,donation_items.influencers.first_name,donation_items.influencers.last_name,donation_items.influencers.avatar,donation_items.project_id.translations.name,donation_items.category_id.translations.name,donation_items.tag_id.translations.name,donation_items.project_id.web_pic&sort=-id&page=${page}`;
  const navigate = useNavigate();
  const ability = useAbility(AbilityContext);
  const authContext = useContext(AuthContext);

  useEffect(() => {
    (async () => {
      setIsAdmin(await authContext.isCurrentUserAdmin());
    })();
  }, []);

  useEffect(() => {
    (async () => {
      setIsAdmin(await authContext.isCurrentUserAdmin());
      const successDonations = await CrudService.getData(
        `items/donation?aggregate[countDistinct]=id&aggregate[sum]=PurchAmount&filter[donation_status][_eq]=paid${filterUrlForSum}`,
      );
      let successDonationCount = successDonations.data[0].countDistinct.id;
      let successDonationSum = successDonations.data[0].sum.PurchAmount;

      const faildDonation = await CrudService.getData(
        `items/donation?aggregate[countDistinct]=id&aggregate[sum]=cost&filter[donation_status][_neq]=paid${filterUrlForSum}`,
      );

      let faildDonationCount = faildDonation.data[0].countDistinct.id;
      let faildDonationSum = faildDonation.data[0].sum.cost;

      setCData([
        {
          number: successDonationCount || "0",
          title: "عدد العمليات الناجحة",
        },
        {
          number: successDonationSum || "0",
          title: "قيمة العمليات الناجحة",
        },
        {
          number: faildDonationCount || "0",
          title: "عدد العمليات الفاشلة",
        },
        {
          number: faildDonationSum || "0",
          title: "قيمة العمليات الفاشلة",
        },
      ]);
    })();
  }, [filterUrl, filterUrlForSum]);

  const getDonations = async (filUrl) => {
    const response = await CrudService.getData(`${reqUrl}${filUrl}`);
    setDonations(response.data);
    setMeta(response.meta);
  };

  useEffect(() => {
    if (limitChange) {
      setLimitChange(false);
      return; //to avoid do request two time when it true and false ;now it do only one time when it return to false
    }

    if (filterData) {
      setFilterData(false);
      return; //to avoid do request two time when it true and false ;now it do only one time when it return to false
    }

    let sortUrl = "";
    if (sortVal) {
      sortUrl = `&sort=${sortVal.desc ? "-" : "+"}${sortVal.id}`;
    }
    getDonations(`${filterUrl}${sortUrl}`);
  }, [page, limitChange, sortVal, filterData]);

  useEffect(() => {
    if (page !== 1) setPage(1);
    else if (filterUrl !== "") setFilterData(true); // to do any action to fire useEffect which fire when filterData changed to do getDonations function and aproove that sort value exist
  }, [filterUrl]);

  useEffect(() => {
    if (!state) return;
    setNotification({
      value: state.value,
      text: state.text,
    });
  }, [state]);

  useEffect(() => {
    if (notification.value === true) {
      setTimeout(() => {
        setNotification({
          value: false,
          text: "",
        });
      }, 5000);
    }
  }, [notification]);

  const clickAddHandler = () => {
    navigate("/donationManagement/donations/add");
  };

  const clickEditHandler = (id) => {
    navigate(`/donationManagement/donations/update/${id}`);
  };

  const getRows = (info) => {
    let updatedInfo = info.map((row) => {
      return {
        ...row,
        dateCreated: moment(row?.date_created).format("YYYY-MM-DDTHH:mm"),
        orderId: row.OrderId || row.provider_order_id,
        cart: row.donation_items.length || 0,
        cartItems: row.donation_items,
        customer: [
          row.user,
          {
            image: `${baseUrl}assets/${row.user_created?.avatar}`,
          },
        ],
      };
    });
    return updatedInfo;
  };

  const col = useMemo(
    () => [
      {
        Header: t("id"),
        accessor: "id",
        Cell: ({ value }) => <IdCell id={value || ""} />,
      },
      {
        Header: t("order"),
        accessor: "orderId",
        Cell: ({ value }) => <IdCell id={value || ""} />,
      },
      {
        Header: "تاريخ العملية",
        accessor: "dateCreated",
        Cell: ({ value }) => <DefaultCell value={value} />,
      },
      {
        Header: "تاريخ التحصيل",
        hidden: true,
        accessor: "TransactionDate",
        Cell: ({ value }) => <DefaultCell value={value} />,
      },
      {
        width: "15%",
        Header: "مرحلة العملية",
        accessor: "donation_status",
        Cell: ({ value }) => <DefaultCell value={value} />,
      },
      {
        Header: "حالة البنك",
        // hidden: true,
        accessor: "TxnResult",
        Cell: (info) => {
          let status;

          if (info.cell.row.original.TxnResult === "Success") {
            status = (
              <StatusCell
                icon="done"
                color="success"
                status={info.cell.row.original.ErrMsg || ""}
              />
            );
          } else if (info.cell.row.original.TxnResult === "Failed") {
            status = (
              <StatusCell
                icon="close"
                color="error"
                status={info.cell.row.original.ErrMsg || ""}
              />
            );
          } else {
            status = (
              <StatusCell
                icon="replay"
                color="dark"
                status={info.cell.row.original.ErrMsg || ""}
              />
            );
          }

          return status;
        },
      },
      {
        Header: "المتبرعين",
        hidden: true,
        accessor: "customer",
        Cell: ({ value: [name, data] }) => (
          <CustomerCell
            image={data.image}
            // color="transparent"
            color="dark"
            name={name || ""}
          />
        ),
      },
      {
        Header: t("country"),
        accessor: "country",
        hidden: true,
        Cell: ({ value }) => <DefaultCell value={value} />,
      },
      {
        Header: "اللغة",
        accessor: "lang",
        hidden: true,
        Cell: ({ value }) => <DefaultCell value={value} />,
      },
      {
        Header: t("items"),
        accessor: "cart",
        hidden: true,
        Cell: (info) => {
          return (
            <MDBox
              onClick={() =>
                showCartItems(info.cell.row.original.cartItems || [])
              }
            >
              <DefaultCell value={info.cell.row.original.cart} suffix={""} />
            </MDBox>
          );
        },
      },
      {
        Header: "تم تحصيل",
        accessor: "PurchAmount",
        Cell: ({ value }) => (
          <DefaultCell value={value} suffix={value ? "TRY" : ""} />
        ),
      },
      {
        Header: "المتبرع به",
        accessor: "cost",
        Cell: ({ value }) => (
          <DefaultCell value={value} suffix={value ? "TRY" : ""} />
        ),
      },
      {
        Header: "المبلغ الحقيقي",
        width: "15%",
        accessor: "total_amount_original",
        Cell: (info) => (
          <DefaultCell
            value={info.cell.row.original.total_amount_original}
            suffix={
              info.cell.row.original.total_amount_original
                ? info.cell.row.original.original_currency
                : ""
            }
            // suffix={info.cell.row.original.original_currency}
          />
        ),
      },
      {
        Header: "فرق العملة",
        accessor: "exchange_rate",
        Cell: ({ value }) => (
          <DefaultCell value={value} suffix={value ? "TRY" : ""} />
        ),
      },
      {
        Header: "الملاحظات",
        accessor: "Description",
        hidden: true,
        Cell: ({ value }) => <DefaultCell value={value} />,
      },
      {
        Header: t("actions"),
        disableSortBy: true,
        accessor: "",
        // hidden: true,
        Cell: (info) => {
          return (
            isAdmin && (
              <MDBox display="flex" alignItems="center">
                <MDButton
                  sx={{ mx: 1, width: "auto", padding: "6px 12px" }}
                  variant="outlined"
                  color={"info"}
                  size="medium"
                  iconOnly
                  onClick={() => addNotes(info.cell.row.original)}
                >
                  <Icon sx={{ fontWeight: "bold" }}>edit</Icon>
                  &nbsp;
                  <Tooltip title="إضافة ملاحظات">
                    <span>إضافة ملاحظات</span>
                  </Tooltip>
                </MDButton>
                <DonationDialog donation={info.cell.row.original} />
                {/* {info.cell.row.original.ProcReturnCode === "00" && (
                  <DownloadButton donation={info.cell.row.original} />
                )} */}

                {/* <PDFDownloadLink
                  document={<ReceiptPdf donation={info.cell.row.original} />}
                  fileName={`donation-${info.cell.row.original.OrderId}.pdf`}
                >
                  {({ loading }) => (loading ? "جاري التحميل..." : "تحميل PDF")}
                </PDFDownloadLink> */}
                {/* import { PDFDownloadLink } from "@react-pdf/renderer";
import MDButton from "components/MDButton";
import { DonationReceipt } from "./pdf/DonationReceipt"; */}

                {/* <PDFDownloadLink
                  document={<ReceiptPdf donation={info.cell.row.original} />}
                  fileName={`donation-${info.cell.row.original.OrderId}.pdf`}
                  style={{ textDecoration: "none" }} // remove <a> styling
                >
                  {({ loading }) => (
                    <MDButton
                      color="success"
                      variant="contained"
                      disabled={loading}
                    >
                      {loading ? "جاري إنشاء الملف..." : "تحميل الإيصال PDF"}
                    </MDButton>
                  )}
                </PDFDownloadLink> */}
              </MDBox>
            )
          );
        },
      },
    ],
    [isAdmin],
  );
  // tableData

  useEffect(() => {
    setTableData(getRows(donations));
  }, [donations]);

  const clickDeleteHandler = async (e, id) => {
    try {
      if (!window.confirm(t("confirmDelete"))) {
        e.nativeEvent.stopImmediatePropagation();
      } else {
        await CrudService.removeItem(`items/donation/${id}`);
        // the delete does not send a response
        // so I need to get again the items to set it and this way the table gets updated -> it goes to the useEffect with data dependecy
        const response = await CrudService.getData(`${reqUrl}${filterUrl}`);
        setDonations(response.data);
        setNotification({
          value: true,
          text: t("deleteSuccessfully"),
        });
      }
    } catch (err) {
      // it sends error is the category is associated with an item
      console.error(err);
      if (err.hasOwnProperty("errors")) {
        setNotification({
          value: true,
          text: err.errors[0].title,
        });
      }
      return null;
    }
  };

  const showCartItems = (data) => {
    let arr = [];
    data?.map((d) => {
      // let cat = "";
      // d.project_id.categories.map(
      //   (c) => (cat += c.categories_id?.translations[0].name + " ")
      // );
      arr.push({
        ...d,
        project: d.project_id?.translations[0].name,
        image: d.project_id?.web_pic,
        category: d.category_id?.translations[0].name,
        // cost: d.cost,
        influencers: d.influencers
          ? `${d.influencers?.first_name} ${d.influencers?.last_name}`
          : null,
        iimage: d.influencers
          ? `${d.influencers?.avatar} ${d.influencers?.avatar}`
          : null,
      });
    });
    setCartItemsData(arr);
    setOpen(data.length > 0);
  };

  const addNotes = (id) => {
    setCartDataId(id);
    setNotesOpen(true);
  };

  const addNotification = async () => {
    await CrudService.updateItem(`items/donation/${cartDataId.id}`, {
      Description: notes,
    });
    let sortUrl = "";
    if (sortVal) {
      sortUrl = `&sort=${sortVal.desc ? "-" : "+"}${sortVal.id}`;
    }
    getDonations(`${filterUrl}${sortUrl}`);
    setNotes("");
  };

  useEffect(() => {
    if (!notesOpen) {
      setNotes("");
      setCartDataId(null);
    } else {
      setNotes(cartDataId.Description);
    }
  }, [notesOpen]);

  const getCsvRows = (info) => {
    let updatedInfo = info.map((row) => {
      let csv = {
        "الرقم التسلسلي": row.id,
        "رقم الطلب": row?.OrderId,
        " تاريخ العملية": row.dateCreated,
        "تاريخ التحصيل": row.TransactionDate,
        "مرحلة البنك": row.TxnResult,
        "مرحلة الطلب": row.donation_status,
        الحالة: row.status_id?.translations[0]?.name,
        المتبرع: row?.user,
        البلد: row?.country,
        اللغة: row?.lang,
        "تم تحصيل": row.PurchAmount,
        "المتبرع به": row.cost,
        "المبلغ الحقيقي": `${row.total_amount_original} ${row.original_currency}`,
        "فرق العملة": row.exchange_rate,
      };
      const keys = Object.keys(csv);
      let csvObj = {};
      keys.forEach((element) => {
        csvObj[t(element)] = csv[element];
      });
      return csvObj;
    });
    return updatedInfo;
  };

  return (
    <DashboardLayout>
      {notification.value && (
        <MDAlert color="info" my="20px">
          <MDTypography variant="body2" color="white">
            {notification.text}
          </MDTypography>
        </MDAlert>
      )}
      <MDBox pt={3} pb={3} mb={3}>
        <Card sx={{ mb: 1 }}>
          <MDBox
            p={3}
            lineHeight={1}
            display="flex"
            justifyContent="space-between"
          >
            <MDTypography variant="h5" fontWeight="medium" color="info">
              {t("donations")}
            </MDTypography>
            <MDBox display="flex">
              {(ability.can("create", "donation") || isAdmin) && (
                <MDButton
                  onClick={clickAddHandler}
                  variant="outlined"
                  color={"info"}
                  size="medium"
                  iconOnly
                  sx={{ mx: 1, width: "auto", padding: "6px 12px" }}
                >
                  <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                  &nbsp;
                  <Tooltip title=" إضافة تبرع جديد">
                    <span>إضافة تبرع جديد </span>
                  </Tooltip>
                </MDButton>
              )}
              {(ability.can("create", "donation") || isAdmin) && (
                <MailComposerDialog
                  users={tableData}
                  setNotification={setNotification}
                />
              )}
              <MDButton
                onClick={() => setShowFilter(!showFilter)}
                variant="outlined"
                color={"info"}
                size="medium"
                iconOnly
                sx={{ mx: 1, width: "auto", padding: "6px 12px" }}
              >
                <Icon sx={{ fontWeight: "bold" }}>search</Icon>
                &nbsp;
                <Tooltip title=" بحث">
                  <span>بحث </span>
                </Tooltip>
              </MDButton>
              {isAdmin && (
                // <CsvDownloadButton
                //   data={getCsvRows(dataTableData.rows)}
                //   style={{
                //     backgroundColor: "white",
                //     color: colors.info.main,
                //     borderColor: colors.info.main,
                //     borderWidth: 1,
                //     fontSize: "16px",
                //     borderRadius: "6px",
                //     fontWeight: "bold",
                //     width: "auto",
                //     // padding: "8px 12px",
                //     marginRight: "8px",
                //   }}
                // >
                //   <Icon sx={{ fontWeight: "bold" }}>import_export</Icon>
                //   &nbsp;
                //   <Tooltip title="تصدير">
                //     <span> تصدير </span>
                //   </Tooltip>
                // </CsvDownloadButton>
                <CsvDownloadButton
                  data={getCsvRows(tableData)}
                  style={{
                    backgroundColor: "white",
                    color: colors.info.main,
                    borderColor: "#FF5528",
                    borderWidth: 1,
                    fontSize: "16px",
                    borderRadius: "6px",
                    fontWeight: "bold",
                    width: "auto",
                    padding: "8px 12px",
                    marginRight: "8px",
                  }}
                >
                  <Icon sx={{ fontWeight: "bold" }}>import_export</Icon>
                  &nbsp;
                  <Tooltip title="تصدير">
                    <span> تصدير </span>
                  </Tooltip>
                </CsvDownloadButton>
              )}
            </MDBox>
          </MDBox>
        </Card>
        <Dialog onClose={() => setOpen(false)} open={open}>
          <ProfilesList
            title="المشاريع"
            profiles={cartItemsData.map((c) => {
              return {
                image: `${baseUrl}assets/${c.image}`,
                name: `${c.project} ${
                  c.quantity ? "- عدد: " + c.quantity : ""
                }`,
                description: `المبلغ الأصلي: ${c.cost} ${
                  c.original_currency || ""
                }, فرق العملة: ${c.exchange_rate || ""}, تم تحصيل: ${
                  +c.cost * (+c.exchange_rate || 1)
                } TRY`,
                recurringData: {
                  is_recurring: c.is_recurring,
                  recurring_frequency: c.recurring_frequency,
                  recurring_duration: c.recurring_duration,
                },
                udhiyah: {
                  quantity: c.quantity,
                  recipientName: c.metadata?.recipientName,
                },
                action: [],
              };
            })}
          />
        </Dialog>
        <Dialog
          onClose={() => setNotesOpen(false)}
          open={notesOpen}
          fullWidth
          maxWidth="md"
        >
          <DialogTitle>إضافة ملاحظات</DialogTitle>

          <DialogContent dividers>
            <MDBox data-color-mode="light">
              <FormField
                multiline
                rows={5}
                fullWidth
                label="ملاحظات"
                value={notes}
                onChange={(e) => setNotes(e.target.value)}
              />
            </MDBox>
          </DialogContent>

          <DialogActions>
            <MDButton onClick={() => setNotesOpen(false)} color="error">
              إلغاء
            </MDButton>

            <MDButton
              onClick={addNotification}
              variant="contained"
              color="info"
              // disabled={loading}
            >
              إرسال
            </MDButton>
          </DialogActions>
        </Dialog>
        {cData.length > 0 && (
          <Grid
            container
            spacing={1}
            display="flex"
            justifyContent="space-around"
            px={15}
            sx={{ py: 1 }}
          >
            <Grid item xs={12} md={2}>
              <DefaultInfoCard
                color="success"
                icon="calculate"
                title={cData[0].title}
                value={cData[0].number}
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <DefaultInfoCard
                color="success"
                icon="volunteer_activism"
                title={cData[1].title}
                value={cData[1].number}
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <DefaultInfoCard
                color="error"
                icon="calculate"
                title={cData[2].title}
                value={cData[2].number}
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <DefaultInfoCard
                color="error"
                icon="volunteer_activism"
                title={cData[3].title}
                value={cData[3].number}
              />
            </Grid>
          </Grid>
        )}
        <Grid container spacing={1}>
          <Grid item xs={12} lg={showFilter ? 9.5 : 12}>
            <DataTable
              setLimitChange={setLimitChange}
              // table={dataTableData}
              table={{ columns: col, rows: tableData }}
              meta={meta}
              setPage={setPage}
              setSortVal={setSortVal}
              pageNum={page}
              isSorted={false}
              canAddCol={true}
            />
          </Grid>
          {showFilter && (
            <Grid item xs={12} lg={2.5}>
              <Card>
                <FilterDonation
                  setFilterUrl={setFilterUrl}
                  setFilterUrlForSum={setFilterUrlForSum}
                />
              </Card>
            </Grid>
          )}
        </Grid>
        {/* </Card> */}
      </MDBox>
    </DashboardLayout>
  );
}

export default Donations;
